import React from "react";

function Resume() {
  return <p>Resume</p>;
}

export default Resume;
